<div class="flex max-width-lg pb-64 pt-40">
  <div class="flex flex-col">
    <div class="mat-headline-4 mb-10">{{ 'CATALOGUE.DISCOVER_TEMENOS_SERVICES' | transloco }}</div>
  </div>
  <div class="flex flex-row basis-full">
    <div class="left-panel pt-24 pr-0" *ngIf="verticalMenuItems">
      <app-vertical-menu [menuItems]="verticalMenuItems" (selected)="selectLineOfBusiness($event)"></app-vertical-menu>
    </div>
    <div class="flex basis-full right-panel p-24" *ngIf="selectedLineOfBusiness">
      <div class="flex flex-col">
        <div class="mat-headline-4 mb-24">{{selectedLineOfBusiness.displayName}}</div>
        <div class="mat-body-1 mb-40">{{selectedLineOfBusiness.shortDescription}}</div>
        <div class="flex flex-row flex-wrap">
          <app-new-solution-card class="flex solution pr-24 pb-24"
                            *ngFor="let solution of groupedSolutions[selectedLineOfBusiness.name]"
                            [solution]="solution"
                            [lineOfBusinessMap]="lineOfBusinessMap">
          </app-new-solution-card>
        </div>
      </div>
    </div>
  </div>
</div>
